import { render, staticRenderFns } from "./PdrbDialog.vue?vue&type=template&id=154ba2f8&scoped=true"
import script from "./PdrbDialog.vue?vue&type=script&lang=js"
export * from "./PdrbDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ba2f8",
  null
  
)

export default component.exports